import { navigate } from "../router";
import { el, mount } from "../ui";
import { getProfile } from "../liff-init";

interface Tile {
  route: string;
  icon: string;
  label: string;
  desc: string;
  featured?: boolean;
  comingSoon?: boolean;
}

const TILES: Tile[] = [
  {
    route: "booking",
    icon: "🌿",
    label: "預約導覽",
    desc: "藥草解說 · 園區巡禮",
    featured: true,
  },
  {
    route: "herbs",
    icon: "🌱",
    label: "藥草圖鑑",
    desc: "認識園區藥草",
    comingSoon: true,
  },
  {
    route: "map",
    icon: "🗺️",
    label: "園區地圖",
    desc: "步道 · 設施位置",
    comingSoon: true,
  },
  {
    route: "events",
    icon: "📅",
    label: "活動報名",
    desc: "近期講座與工作坊",
    comingSoon: true,
  },
  {
    route: "restaurant",
    icon: "🍲",
    label: "餐廳訂位",
    desc: "汆燙鍋 · 健康養生餐",
    comingSoon: true,
  },
];

export function renderHome(): void {
  const profile = getProfile();
  const greeting = profile?.displayName ? `嗨,${profile.displayName} 🌿` : "歡迎您 🌿";

  const hero = el("section", { class: "hero" }, [
    el("p", { class: "greeting" }, [greeting]),
    el("h2", {}, ["台東原生應用植物園"]),
    el("p", {}, ["藥草解說 · 健康養生 · 戶外療癒"]),
  ]);

  const grid = el("section", { class: "tile-grid" });
  for (const t of TILES) {
    const cls = ["tile"];
    if (t.featured) cls.push("featured");
    if (t.comingSoon) cls.push("coming-soon");
    const tile = el("button", { class: cls.join(" "), "aria-label": t.label }, [
      el("span", { class: "icon" }, [t.icon]),
      el("span", { class: "label" }, [t.label]),
      el("span", { class: "desc" }, [t.desc]),
    ]);
    if (t.featured) tile.appendChild(el("span", { class: "badge" }, ["熱門"]));
    if (t.comingSoon) tile.appendChild(el("span", { class: "badge" }, ["敬請期待"]));
    tile.addEventListener("click", () => navigate(t.route));
    grid.appendChild(tile);
  }

  const foot = el("div", { class: "foot-note" }, [
    "有問題隨時跟「原生小幫手 🌿」對話 · ",
    el("a", { href: "https://ttyuansen.com", target: "_blank", rel: "noopener" }, ["前往官網"]),
  ]);

  mount(hero, grid, foot);
}
